import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "context/auth-context";
import {
  AfterVerificatiobProcess,
  ResendOtpForClaim,
  verifyZampliaSurveys,
} from "./MyReferralPage.api";
import { useLocation, useNavigate, NavigateFunction } from "react-router-dom";
// import PropTypes from "prop-types";
import LoadingOverlay from "react-loading-overlay-ts";
import { Modal } from "antd";
import { FiCheck, FiMail, FiShield, FiSmartphone } from "react-icons/fi";
import { PageHeader } from "components/ui";

const OTP_STEPS = ["Choose reward", "Confirm details", "Verify"];

const reqDataIntialState = {
  type: "",
  id: "",
};

const reqIntialState = {
  emailOtp: "",
  smsOtp: "",
  id: "",
  panelListId: +"",
  cashout: "",
  service: "",
  errors: {
    email: "",
    mobile: "",
  },
};
type reqDataType = typeof reqDataIntialState;
type FormState = typeof reqIntialState;
type ClaimDataType = typeof reqIntialState;

export const OtpRewarddata = () => {
  const navigate: NavigateFunction = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { auth } = useAuth();
  const [data, setData] = useState<reqDataType>(reqDataIntialState);
  const [formState, setFormState] = useState<FormState>(reqIntialState);
  const [updateActiveStatus, setUpdateActiveStatus] = useState(false);

  // useMutation for hitting api to debit points in claim history table when bonus is claimed
  const runAfterVerificationQuery = useMutation(
    ["afterVerification"],
    () => {
      return AfterVerificatiobProcess(auth.panelistId);
    },
    {
      onSuccess: (data: { success: boolean; message: string }) => {
        if (data.success) {
          navigate("/my-referral", { replace: true });
        }
      },
      onError: (error: Error) => {
        // Log the error or display a user-friendly message
        alert("An error occurred: " + error.message);
      },
    }
  );

  const VerifyOtp = useMutation(
    ["verifyotp"],
    () =>
      verifyZampliaSurveys(
        Number(formState.emailOtp),
        Number(formState.smsOtp),
        formState.id,
        formState.panelListId,
        formState.cashout,
        formState.service,
        JSON.parse(localStorage.getItem("ApprovedStudyId") || "[]")
      ),
    {
      onSuccess(response: any) {
        setData(reqDataIntialState);
        if (response.success && location.state.service !== "Bonus") {
          Modal.success({
            title: "Success!",
            content: response.message,
            onOk() {
              navigate("/otp", {});
              if (location.state.service === "Referral Wallet") {
                navigate("/my-referral");
              } else if (location.state.service === "Streak Wallet") {
                navigate("/Dashboard");
              } else if (location.state.service === "Study") {
                navigate("/Dashboard");
              } else {
                navigate("/");
              }
            },
          });
        } else if (response.success && location.state.service === "Bonus") {
          Modal.success({
            title: "Success!",
            content: response.message,
            onOk() {
              setUpdateActiveStatus(true);
            },
          });
        } else {
          setData(reqDataIntialState);
          Modal.error({
            title: "Encountered an error!",
            content: response.message,
            onOk() {
              navigate("/Dashboard");
            },
          });
        }
      },
      onError(error: any) {
        if (error && error.response?.data) {
          Modal.error({
            title: "Encountered an error!",
            content: error.response.data.message,
            onOk() {
              navigate("/Dashboard");
            },
          });
        }
      },
    }
  );
  const ResendOtp = useMutation(["otp"], () => ResendOtpForClaim(data.type, data.id), {
    onSuccess(response: any) {
      setData(reqDataIntialState);
      if (response.success) {
        Modal.success({
          title: "Success!",
          content: response.message,
        });
      } else {
        Modal.error({
          title: "Encountered an error!",
          content: "Something went wrong",
        });
      }
    },
    onError(error: any) {
      setData(reqDataIntialState);
      if (error && error.response?.data) {
        Modal.error({
          title: "Encountered an error!",
          content: error.response.data.message,
        });
      }
    },
  });

  // function mobileOtp() {
  //   setData({
  //     type: "mobile",
  //     id: location.state.requestId,
  //   });
  // }

  // function emailOtp() {
  //   setData({
  //     type: "email",
  //     id: location.state.requestId,
  //   });
  // }

  //to check request id is exist or not
  useEffect(() => {
    if (!location.state) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (data.type && data.type !== "") {
      ResendOtp.mutate();
    }

    if (updateActiveStatus) {
      runAfterVerificationQuery.mutate();
    }
  }, [data, updateActiveStatus]);

  const validation = (formValues: FormState) => {
    setFormState((old: ClaimDataType) => {
      return {
        ...old,
        errors: { ...old.errors, email: "", mobile: "" },
      };
    });

    if (!formValues.emailOtp) {
      setFormState((old) => {
        return { ...old, errors: { ...old.errors, email: t("page.referral.mandatory") } };
      });
      return false;
    }

    if (!formValues.smsOtp) {
      setFormState((old: ClaimDataType) => {
        return { ...old, errors: { ...old.errors, mobile: t("page.referral.fill") } };
      });
      return false;
    }
    return true;
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement | HTMLSelectElement> = (e) => {
    e.preventDefault();
    const valid = validation(formState);
    if (valid) {
      VerifyOtp.mutate();
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [event.target.name]: event.target.value,
      id: location.state.requestId,
      panelListId: auth.panelistId,
      service: location.state.service,
      cashout:
        location.state.service === "Referral Wallet"
          ? "zampliasurveys referral cashout"
          : "zampliasurveys cashout",
    });
  };

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
          background: "rgb(var(--zs-overlay) / 0.45)",
        }),
      }}
      active={VerifyOtp.isLoading || ResendOtp.isLoading}
      spinner
      text={t("claim.card.Loading")}
    >
      <div className="zs-page zs-page-narrow">
        <PageHeader
          eyebrow="Rewards"
          title={t("page.referral.Reward")}
          subtitle="Enter the one-time codes sent to your email and phone to confirm this redemption."
        />

        <ol className="grid grid-cols-3 gap-2 mb-4" aria-label="Redemption progress">
          {OTP_STEPS.map((label, index) => {
            const isCurrent = index === OTP_STEPS.length - 1;
            return (
              <li key={label} className="flex flex-col gap-2">
                <span className={`h-1 rounded-full ${isCurrent ? "bg-primary" : "bg-success"}`} />
                <span
                  className={`flex items-center gap-1.5 text-xs font-medium ${isCurrent ? "text-ink" : "text-ink-3"}`}
                  aria-current={isCurrent ? "step" : undefined}
                >
                  {!isCurrent && <FiCheck className="text-success shrink-0" />}
                  {label}
                </span>
              </li>
            );
          })}
        </ol>

        <section className="zs-card">
          <div className="zs-card-header">
            <div className="flex items-center gap-3 min-w-0">
              <span className="zs-stat-icon">
                <FiShield />
              </span>
              <div className="min-w-0">
                <h2 className="zs-card-title">Verify your request</h2>
                <p className="mt-0.5 zs-card-subtitle">Codes can take a minute to arrive.</p>
              </div>
            </div>
          </div>
          <form method="post" id="claimRewardFirstStep" className="zs-card-body" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-4">
              <div className="form-group">
                <label className="zs-label zs-label-required" htmlFor="emailOtp">
                  {t("page.referral.emailotp")}
                </label>
                <div className="zs-search">
                  <FiMail />
                  <input
                    type="text"
                    className="zs-input form-control tracking-[0.2em] tabular-nums"
                    id="emailOtp"
                    name="emailOtp"
                    autoComplete="one-time-code"
                    aria-invalid={formState.errors.email ? "true" : undefined}
                    value={formState.emailOtp}
                    onChange={handleChange}
                  />
                </div>
                {formState.errors.email ? (
                  <p className="zs-error" id="emai_err_msg">
                    {formState.errors.email}
                  </p>
                ) : null}
              </div>
              <div className="form-group">
                <label className="zs-label zs-label-required" htmlFor="smsOtp">
                  {t("page.referral.Mobileotp")}
                </label>
                <div className="zs-search">
                  <FiSmartphone />
                  <input
                    type="text"
                    className="zs-input form-control tracking-[0.2em] tabular-nums"
                    id="smsOtp"
                    name="smsOtp"
                    autoComplete="one-time-code"
                    aria-invalid={formState.errors.mobile ? "true" : undefined}
                    value={formState.smsOtp}
                    onChange={handleChange}
                  />
                </div>
                {formState.errors.mobile ? (
                  <p className="zs-error" id="emai_err_msg">
                    {formState.errors.mobile}
                  </p>
                ) : null}
              </div>
              <div className="w-full pt-2 form-group">
                <button type="submit" className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
                  {t("page.referral.claim")}
                </button>
              </div>
            </div>
          </form>
        </section>
      </div>
    </LoadingOverlay>
  );
};
